import { render, staticRenderFns } from "./QRInput.vue?vue&type=template&id=2833a402&scoped=true&lang=pug&"
import script from "./QRInput.vue?vue&type=script&lang=js&"
export * from "./QRInput.vue?vue&type=script&lang=js&"
import style0 from "./QRInput.vue?vue&type=style&index=0&id=2833a402&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2833a402",
  null
  
)

export default component.exports